
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[id]",
      function () {
        return require("private-next-pages/events/[id].tsx");
      }
    ]);
  